import React from 'react';
import Button from '@mui/material/Button';

const styles = {
  centerblock: {
    textAlign:'center'
  }
}

/*
  @booolean   saveStatus
  @boolean    saveSuccess
  @closure    speichern
  @string     saveMessage
*/

class Speichersektion extends React.Component {

  state = {
    showFehler:false,
  }

  vorSpeicherung = () => {
    return (
      <div style={styles.centerblock}>
        
        <Button
          variant="contained"
          color="success"
          size="large"
          fullWidth={true}
          disabled={this.props.disabled}
          onClick={
            ()=>{
              this.props.speichern(this.props.optionalSuccessFunction)
            }
          }
        >
          &nbsp;<br/>{this.props.title}<br/>&nbsp;
        </Button>
      </div>
    )
  }

  nachSpeicherung = () => {

    if (this.props.saveMessage && this.props.debug) {
      return this.speicherungMitFehlern()
    }

    if (this.props.saveSuccess) {
      return this.speicherungOhneFehler()
    }
    return this.speicherungMitFehlern()
  }

  speicherungOhneFehler = () => {
    return (
      <div style={styles.centerblock}>
        <h2>Gespeichert</h2>
      </div>
    )
  }

  speicherungMitFehlern = () => {
    let arr = []
    arr.push(
      <h2 key="ERR.1">Mit Fehlern gespeichert</h2>
    )
    if (this.state.showFehler) {
      arr.push(
        <Button
          key="SpeicherFehlerAusblenden"
          onClick={()=>this.setState({showFehler:false})}
        >
          Fehler ausblenden
        </Button>
      )
      arr.push(this.fehlermeldungen())
    } else {
      arr.push(
        <Button
          key="SpeicherFehlerZeigen"
          onClick={()=>this.setState({showFehler:true})}
        >
          Fehler zeigen
        </Button>
      )
    }

    return arr
  }

  fehlermeldungen = () => {
    return (
      <div key="FehlerMsg">
        {this.props.saveMessage}
      </div>
    )
  }


  render () {
    if (this.props.saveStatus) {
      return (<div>{this.nachSpeicherung()}</div>)
    }
    return (<div>{this.vorSpeicherung()}</div>)
  }

}

export default Speichersektion;
